import React from 'react';
import { CheckCircleIcon, ExclamationTriangleIcon, XCircleIcon, InformationCircleIcon } from '@heroicons/react/24/solid';

const successAlert = {
    icon: <CheckCircleIcon className="h-6 w-6 text-green-500" aria-hidden="true" />,
    backgroundColor: 'bg-green-200',
    alertHeading: 'text-green-950 uppercase',
    textColor: 'text-green-900',
};

const attentionAlert = {
    icon: <ExclamationTriangleIcon className="h-6 w-6 text-yellow-500" aria-hidden="true" />,
    backgroundColor: 'bg-yellow-200',
    alertHeading: 'text-yellow-950 uppercase',
    textColor: 'text-yellow-900',
};

const dangerAlert = {
    icon: <XCircleIcon className="h-6 w-6 text-red-500" aria-hidden="true" />,
    backgroundColor: 'bg-red-200',
    alertHeading: 'text-red-950 uppercase',
    textColor: 'text-red-900',
};

const infoAlert = {
    icon: <InformationCircleIcon className="h-6 w-6 text-blue-500" aria-hidden="true" />,
    backgroundColor: 'bg-blue-200',
    alertHeading: 'text-blue-950 uppercase',
    textColor: 'text-blue-900',
};

export { successAlert, attentionAlert, dangerAlert, infoAlert };